

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';


import router from './router/router.js'      
import Base from './assets/js/baseFun.js'         
import stores from './store/store'                
import './assets/css/base.css'                    
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import VueVideoPlayer from 'vue-video-player';
import VueCropper  from 'vue-cropper';


FastClick.attach(document.body)
Vue.config.productionTip = false


Vue.prototype.baseFun=Base.baseFun;  
Vue.prototype.baseAjax=Base.baseAjax;

Vue.use(VueRouter)
Vue.use(WechatPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VueVideoPlayer);
Vue.use(VueCropper)

NutUI.install(Vue);

var globalVm=new Vue({
router,            //-----router文件
el: '#app',
store:stores,          //-----全局变量
template: '<App/>',
components: { App }
})










// WEBPACK FOOTER //
// ./src/main.js